import {
  RangeDatePicker,
  type FocusState,
  type RangeDatePickerProperties,
} from "@jetblue/kit/date-picker/range";
import { useState } from "react";
import type { FlightSearchFormLabels } from "../../labels";
import { BestFaresToolbar } from "../../toolbar/best-fares-toolbar";
import type { BestFaresCalendarQueryInput } from "../../hooks/use-best-fares-calendar";
import { useBestFaresPickerState } from "./use-best-fares-picker-state";

export type BestFaresRangeDatePickerProperties = Pick<
  RangeDatePickerProperties,
  | "departIsRequired"
  | "endDate"
  | "labels"
  | "returnIsRequired"
  | "selectedDates"
  | "setSelectedDates"
  | "showValidation"
  | "startDate"
> &
  BestFaresCalendarQueryInput & {
    showDatePickerPricing: boolean;
    toolbarLabels: FlightSearchFormLabels["datePickerToolbar"];
  };
export const BestFaresRangeDatePicker = ({
  destination,
  origin,
  passengers,
  showDatePickerPricing,
  toolbarLabels,
  usePoints,
  ...rangeDatePickerProperties
}: BestFaresRangeDatePickerProperties) => {
  const { endDate, selectedDates, startDate } = rangeDatePickerProperties;
  const [selectedDepartDate, selectedReturnDate] = selectedDates;
  const [focusState, setFocusState] = useState<FocusState>("none");

  const { announcement, message, renderDate, selectedPrice } =
    useBestFaresPickerState({
      destination,
      endDate,
      fareDirection: focusState === "end" ? "inbound" : "outbound",
      origin,
      passengers,
      selectedDepartDate,
      selectedReturnDate,
      showDatePickerPricing,
      startDate,
      toolbarLabels,
      tripType: "round-trip",
      usePoints,
    });
  const footerSlot =
    message || selectedPrice ? (
      <BestFaresToolbar
        announcement={announcement}
        message={message}
        selectedPrice={selectedPrice}
      />
    ) : undefined;

  return (
    <RangeDatePicker
      {...rangeDatePickerProperties}
      footerSlot={footerSlot}
      onFocusStateChange={setFocusState}
      renderDate={renderDate}
    />
  );
};
